import React from 'react';
import { connect } from 'react-redux';
import mobileConfigActions from '../../../../../actions/mobileConfig.actions';
import MobileConfigurationForm from '../CreateEditForm';
import qs from 'qs';
import Backend from '../../../../Layouts/Backend';
import { Loading } from '../../../../UI/Common';

function EditMobileConfiguration(props) {
  const { id } = qs.parse(props.location.search, { ignoreQueryPrefix: true });
  const [isSubmitting, setSubmitting] = React.useState(false);
  const [error, setError] = React.useState('');
  const [mobileConfig, setMobileConfig] = React.useState({});
  function getSpecificMobileConfig() {
    props
      .getSpecificMobileConfig(id)
      .then((resp) => setMobileConfig(resp))
      .catch((err) => console.log(err));
  }
  React.useEffect(() => {
    getSpecificMobileConfig();
  }, []);
  const onEdit = async (values) => {
    setError('');
    setSubmitting(true);
    await props
      .editMobileConfig(id, {
        ...values,
        accessibleTypes: values.accessibleTypes ? 0 : 1,
      })
      .then(() => props.history.goBack())
      .catch((err) => {
        setSubmitting(false);
        setError(err);
      });
  };
  if (props.mobileConfig.loading) {
    return (
      //prettier-ignore
      <Backend><div className='content-inner'><Loading /></div></Backend>
    );
  }
  return (
    <MobileConfigurationForm
      initialValues={{
        ...mobileConfig,
        accessibleTypes: mobileConfig.accessibleTypes === 0 ? true : false,
      }}
      onSubmit={onEdit}
      submitting={isSubmitting}
      errors={error}
      isEdit={true}
    />
  );
}

function mapStateToProps(state) {
  return {
    mobileConfig: state.mobileConfig,
  };
}

export default connect(
  mapStateToProps,
  mobileConfigActions,
)(EditMobileConfiguration);
